import { createElementId, getUnixTimestampUTC } from "../util/utils";
import { ChartType, singleBarChartSchema, singleBarDefaultValues, singleBarFields } from "./schemas/chart";
import { Point } from "./schemas";
import { elementDataLayerSchema } from "./schemas/element-data-layer";

export function placeChart(position: Point, chartType: ChartType) {
  switch (chartType) {
    case ChartType.singleBar:
      return placeSingleBarChart(position);
  }
}

export function placeSingleBarChart({ x, y }: Point) {
  return {
    id: createElementId(),
    item: singleBarChartSchema.parse({
      chartType: ChartType.singleBar,
      x,
      y,
      width: 200,
      height: 30,
      zIndexLastChangeTime: getUnixTimestampUTC(),
      dataLayer: elementDataLayerSchema.parse({
        fieldsOrder: Object.keys(singleBarFields),
        fields: singleBarFields,
        values: singleBarDefaultValues,
      }),
    }),
  };
}
